'use client';

import { c as _c } from "react/compiler-runtime";
import Portal from '@components/portal/Portal';
import ROUTES from '@lib/constants/routes';
import { handleHeaderColorScheme } from '@lib/store/slices/ComponentsSlice';
import { resetSelectedBenefit, setEqualizerOpened } from '@lib/store/slices/EqualizerSlice';
import { setServerAttributes, setServerFlatsData } from '@lib/store/slices/FilterSlice';
import { cleanError, setGenPlan } from '@lib/store/slices/FlatSlice';
import { handleBodyLock } from '@lib/tools/_handle-body-lock';
import { handleBodyUnlock } from '@lib/tools/_handle-body-unlock';
import { pushDataLayer } from '@lib/tools/pushDataLayer';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EqualizerCalculatorModal from '../equalizer/components/equalizer-calculator-modal/EqualizerCalculatorModal';
import style from './FlatCalculator.module.scss';
const MortgageCalculatorFinch = dynamic(() => import('@components/calculator/NewCalculator'));
const FlatCalculator = t0 => {
  const $ = _c(39);
  const {
    flats,
    attributes,
    calcData,
    flatInfo,
    isMobile,
    mortgageGroupOptions
  } = t0;
  const router = useRouter();
  const dispatch = useDispatch();
  const error = useSelector(_temp);
  const maxFloor = useSelector(_temp2);
  const {
    isEqualizerOpen
  } = useSelector(_temp3);
  let t1;
  if ($[0] !== attributes || $[1] !== dispatch || $[2] !== flats) {
    t1 = () => {
      if (attributes) {
        dispatch(setServerAttributes(attributes));
      }
      if (flats) {
        dispatch(setServerFlatsData(flats));
      }
    };
    $[0] = attributes;
    $[1] = dispatch;
    $[2] = flats;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== attributes || $[5] !== flats) {
    t2 = [attributes, flats];
    $[4] = attributes;
    $[5] = flats;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== dispatch || $[8] !== error || $[9] !== router) {
    t3 = () => {
      if (error) {
        console.error("\u041E\u0448\u0438\u0431\u043A\u0430 404: \u041A\u0432\u0430\u0440\u0442\u0438\u0440\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430");
        dispatch(handleHeaderColorScheme("multiOnTransparent"));
        router.push(ROUTES.notFound, {
          replace: true,
          state: {
            status: 404
          }
        });
      }
    };
    $[7] = dispatch;
    $[8] = error;
    $[9] = router;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== error || $[12] !== router) {
    t4 = [error, router];
    $[11] = error;
    $[12] = router;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  useEffect(t3, t4);
  let t5;
  if ($[14] !== dispatch) {
    t5 = () => () => {
      dispatch(setGenPlan(false));
      dispatch(cleanError(false));
    };
    $[14] = dispatch;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  useEffect(t5, t6);
  let t7;
  if ($[17] !== dispatch) {
    t7 = () => {
      pushDataLayer("page_view_flat");
      return () => {
        dispatch(resetSelectedBenefit());
        dispatch(setEqualizerOpened(false));
      };
    };
    $[17] = dispatch;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[20] !== isEqualizerOpen) {
    t9 = () => {
      if (isEqualizerOpen) {
        handleBodyLock();
        document.body.style.overflow = "hidden";
      } else {
        handleBodyUnlock();
        document.body.style.overflow = "auto";
      }
      return _temp4;
    };
    t10 = [isEqualizerOpen];
    $[20] = isEqualizerOpen;
    $[21] = t10;
    $[22] = t9;
  } else {
    t10 = $[21];
    t9 = $[22];
  }
  useEffect(t9, t10);
  if (error) {
    router.push(ROUTES.notFound, {
      replace: true,
      state: {
        status: 404
      }
    });
  }
  let t11;
  if ($[23] !== flatInfo || $[24] !== isEqualizerOpen) {
    t11 = isEqualizerOpen && <Portal><EqualizerCalculatorModal flat={flatInfo} /></Portal>;
    $[23] = flatInfo;
    $[24] = isEqualizerOpen;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== isMobile) {
    t12 = !isMobile && <h3 className={style.calculator__title}>Калькулятор ипотеки</h3>;
    $[26] = isMobile;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== calcData || $[29] !== flatInfo || $[30] !== maxFloor || $[31] !== mortgageGroupOptions) {
    t13 = maxFloor && <MortgageCalculatorFinch calcData={calcData} flat={flatInfo} mortgageGroupOptions={mortgageGroupOptions} />;
    $[28] = calcData;
    $[29] = flatInfo;
    $[30] = maxFloor;
    $[31] = mortgageGroupOptions;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t12 || $[34] !== t13) {
    t14 = <div className={style.calculator} id="calc">{t12}{t13}</div>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t11 || $[37] !== t14) {
    t15 = <>{t11}{t14}</>;
    $[36] = t11;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
};
export default FlatCalculator;
function _temp(state) {
  return state?.flatInfo?.error;
}
function _temp2(state_0) {
  return state_0?.filters?.maxFloor;
}
function _temp3(state_1) {
  return state_1?.equalizer;
}
function _temp4() {
  document.body.style.overflow = "auto";
  handleBodyUnlock();
}